import z from 'zod';
import { InventoryReceiptSchema } from './InventoryReceipt';

export const InventoryReceiptListResultSchema = z.object({
    data: z.array(InventoryReceiptSchema),
    total: z.number(),
});

export type InventoryReceiptListResult = z.infer<typeof InventoryReceiptListResultSchema>;
